/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  getCopilotSetting(inboxId) {
    return axios.get(`${this.url}/${inboxId}/copilot_setting`);
  }

  updateCopilotSetting(inboxId, setting) {
    return axios.patch(`${this.url}/${inboxId}/copilot_setting`, {
      copilot_inbox_setting: setting,
    });
  }

  backfillCopilotAttachments(inboxId, { retryFailedOnly = false } = {}) {
    return axios.post(`${this.url}/${inboxId}/copilot_setting/backfill`, {
      retry_failed_only: retryFailedOnly,
    });
  }
}

export default new Inboxes();
